import { lazy } from 'react';
import Loadable from 'components/Loadable';
import DefaultLayout from 'layout/Default';
import { ProtectedRoute } from 'routes/RouteGuards';

const ManageSettingPage = Loadable(
  lazy(() => import('views/settings/ManageSetting'))
);

const SettingRoutes = {
  path: '/manage-setting',
  element: <ProtectedRoute />,
  children: [
    {
      element: <DefaultLayout />,
      children: [
        {
          index: true,
          element: <ManageSettingPage />
        }
      ]
    }
  ]
};

export default SettingRoutes;
